import type { RefObject } from 'react';

const SUBMENU_GAP_PX = 2;

export function getSubmenuAnchorRect(
  triggerRef: RefObject<HTMLElement | null>,
) {
  const trigger = triggerRef.current;
  if (!trigger) {
    return null;
  }
  const triggerRect = trigger.getBoundingClientRect();
  const parentContent = trigger.closest('[data-part="content"]');
  const parentRect = parentContent?.getBoundingClientRect() ?? triggerRect;
  return {
    x: parentRect.right + SUBMENU_GAP_PX,
    y: triggerRect.top,
    width: 0,
    height: triggerRect.height,
  };
}

export const SUBMENU_POSITIONING_BASE = {
  strategy: 'fixed' as const,
  placement: 'right-start' as const,
  gutter: 0,
  flip: false,
  slide: false,
  overlap: false,
  overflowPadding: 0,
};
